<div class="unassign-dialog-container p-6">
    <h2 mat-dialog-title class="text-xl font-semibold mb-4">Remove from Parking Space Access Group</h2>

    <mat-dialog-content class="space-y-4">
        <!-- Operator Info -->
        <mat-card class="p-4 bg-gray-50">
            <div class="flex items-center space-x-3">
                <mat-icon class="text-blue-600">person</mat-icon>
                <div>
                    <div class="font-medium">{{ getOperatorDisplayName() }}</div>
                    @if (operator.email) {
                    <div class="text-sm text-gray-600">{{ operator.email }}</div>
                    }
                </div>
            </div>
        </mat-card>

        <!-- Check if operator has parking space group memberships -->
        @if (parkingSpaceGroupMemberships.length === 0) {
        <div class="text-center py-8">
            <mat-icon class="text-gray-400 mb-3"
                style="font-size: 48px; height: 48px; width: 48px;">local_parking</mat-icon>
            <p class="text-gray-600">This operator is not assigned to any parking space access groups.</p>
        </div>
        }

        <!-- Group Membership Selection -->
        @if (parkingSpaceGroupMemberships.length > 0) {
        <div>
            <mat-form-field appearance="fill" class="w-full">
                <mat-label>Select parking space access group to remove from</mat-label>
                <mat-select [value]="selectedMembershipId()" (valueChange)="selectedMembershipId.set($event)"
                    [disabled]="isUnassigning()">
                    @for (item of parkingSpaceGroupMemberships; track item.membership.id) {
                    <mat-option [value]="item.membership.id">
                        <div class="space-option">
                            <div class="font-medium">{{ item.membership.operatorGroup?.name || 'Unnamed Group' }}</div>
                            <div class="text-sm text-gray-600">
                                <span>{{ item.parkingSpaceName }}</span>
                                @if(item.membership.operatorGroup?.role)
                                {
                                <span> • Role: {{
                                    item.membership.operatorGroup?.role}}</span>
                                }
                            </div>
                            @if (item.membership.joinedAt) {
                            <div class="text-xs text-gray-500">
                                Joined: {{ item.membership.joinedAt | date:'short' }}
                            </div>
                            }
                        </div>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <!-- Warning message -->
            <div class="bg-yellow-50 border-l-4 border-yellow-400 p-4">
                <div class="flex">
                    <mat-icon class="text-yellow-400 mr-2">warning</mat-icon>
                    <div>
                        <p class="text-sm text-yellow-700">
                            <strong>Warning:</strong> Removing the operator from this access group will revoke their
                            access
                            to the associated parking space(s).
                            This action cannot be undone, but they can be reassigned later.
                        </p>
                    </div>
                </div>

            </div>
        </div>
        }
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="pt-4">
        <button mat-button (click)="onCancel()" [disabled]="isUnassigning()">
            Cancel
        </button>
        <button mat-raised-button color="warn" (click)="onUnassign()"
            [disabled]="!selectedMembershipId() || isUnassigning() || parkingSpaceGroupMemberships.length === 0">
            @if (isUnassigning()) {
            <mat-icon>
                <mat-spinner diameter="16" strokeWidth="2"></mat-spinner>
            </mat-icon>
            }
            @if (!isUnassigning()) {
            <mat-icon>remove_circle</mat-icon>
            }
            {{ isUnassigning() ? 'Removing...' : 'Remove from Group' }}
        </button>
    </mat-dialog-actions>
</div>